export const faqCards = [
    {
        title: 'See a list of popular fitness trackers that sync with our mobile app to log your workouts.',
        imageURL: 'https://asset.yes.fit/homepage/Icon-Tracker.svg',
        cardBG: 'https://asset.yes.fit/homepage/faq-bottom.png',
        cardURL:
            'https://help.yes.fit/en/articles/135792-what-apps-and-devices-sync-with-yes-fit'
    },
    {
        title: 'Learn more about us as a company and our mission to get people off the couch and change lives.',
        imageURL: 'https://asset.yes.fit/homepage/Icon-FAQ.svg',
        cardBG: 'https://asset.yes.fit/homepage/faq-bottom.png',
        cardURL: 'https://help.yes.fit/en/articles/3281146-what-is-yes-fit'
    },
    {
        title: 'Discover our VIP Membership program and the benefits of becoming a member today.',
        imageURL: 'https://asset.yes.fit/homepage/Icon-VIP.svg',
        cardBG: 'https://asset.yes.fit/homepage/faq-bottom.png',
        cardURL: 'https://yes.fit/membership'
    },
    {
        title: 'Find out more info on how our Virtual Races work and finding the right one for you.',
        imageURL: 'https://asset.yes.fit/homepage/Icon-Race.svg',
        cardBG: 'https://asset.yes.fit/homepage/faq-bottom.png',
        cardURL: 'https://help.yes.fit/en/articles/3281157-what-is-a-virtual-race'
    },
    {
        title: 'Learn how to sync your favorite fitness tracker with our mobile app to log your workouts.',
        imageURL: 'https://asset.yes.fit/homepage/Icon-Tracker.svg',
        cardBG: 'https://asset.yes.fit/homepage/faq-bottom.png',
        cardURL:
            'https://help.yes.fit/en/articles/5412954-how-do-you-add-a-fitness-device-to-a-race-within-the-app'
    },
    {
        title: 'Can I count miles doing other activites towards my Race?',
        imageURL: 'https://asset.yes.fit/homepage/Icon-FAQ.svg',
        cardBG: 'https://asset.yes.fit/homepage/faq-bottom.png',
        cardURL:
            'https://help.yes.fit/en/articles/3281234-can-i-count-miles-doing-elliptical-bike-treadmill-or-swimming'
    },
    {
        title: 'Visit our Frequently Asked Questions to learn even more about the full Yes.Fit experience.',
        imageURL: 'https://asset.yes.fit/homepage/Icon-FAQ.svg',
        cardBG: 'https://asset.yes.fit/homepage/faq-bottom.png',
        cardURL: 'https://help.yes.fit/en/'
    }
]
